import React from "react";
import Link from "next/link";
import {CategoryCard} from "@obby/components";

export  function FeaturedCategories(props) {

  const colClass =  "col-12 col-sm-6 col-smd-4  col-lg-2 mb-4"

    return (
      <div className="featured-categories">
        <div className="row">
          <div className={colClass}>
            <CategoryCard
              thumbnail="https://res.cloudinary.com/obby/image/upload/v1627645337/Page%20Images/printing.jpg"
              label="Printing classes"
              url="/classes/art/printing"/>
          </div>
          <div className={colClass}>
            <CategoryCard
              thumbnail="https://res.cloudinary.com/obby/image/upload/v1627645407/Page%20Images/healthbeauty.jpg"
              label="Health & beauty classes"
              url="/classes/health-and-beauty"/>
          </div>
          <div className={colClass}>
            <CategoryCard
              thumbnail="https://res.cloudinary.com/obby/image/upload/v1627645446/Page%20Images/floristry.jpg"
              label="Floristry classes"
              url="/classes/crafts/floristry"/>
          </div>
          <div className={colClass}>
            <CategoryCard
              thumbnail="https://res.cloudinary.com/obby/image/upload/v1627645484/Page%20Images/asian.jpg"
              label="Cooking classes"
              url="/classes/food/cooking"/>
          </div>
          <div className={colClass}>
            <CategoryCard
              thumbnail="https://res.cloudinary.com/obby/image/upload/v1627645615/Page%20Images/handiwork.jpg"
              label="Crafts classes"
              url="/classes/crafts"/>
          </div>
          <div className={colClass}>
            <CategoryCard
              thumbnail="https://res.cloudinary.com/obby/image/upload/v1627645529/Page%20Images/boozy.jpg"
              label="Drinks & Tasting classes"
              url="/classes/drinks-and-tastings"/>
          </div>
        </div></div>
    );
}
